export type FrequencyOptions =
  | 'single'
  | 'daily'
  | 'weekly'
  | 'bi_weekly'
  | 'monthly'
  | 'bi_monthly'
  | 'quarterly'
  | 'quadrimester'
  | 'semiannual'
  | 'annual'

export type Options = 'template' | 'custom' | 'workflow'

export enum Templates {
  climate = 'climate',
  workflow = 'workflow_survey',
}

export enum Types {
  custom = 'custom',
  climate = Templates.climate,
  workflow = Templates.workflow,
}
